import { AdditionalIntakeDto } from '@wisenet/salesapp-client'
import styled from 'styled-components'

const StyledListOfCourses = styled.div`
  div {
    border-bottom: 0.5px solid #fff;
    padding: 6px 0;
  }
  div:last-child {
    border-bottom: none;
  }
`

export const ListOfCourses = (list: AdditionalIntakeDto[]) => {
  if (!list) return <></>
  return (
    <StyledListOfCourses>
      {list?.map(i => (
        <div key={i?.additionalIntakeGuid}>{i?.additionalIntakeName}</div>
      ))}
    </StyledListOfCourses>
  )
}
